import { useQuery } from "@tanstack/react-query";
import { EraControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
} from "../../../utils/utils";

export const useGetEraByUuid = (uuid: string | undefined, enabled = true) =>
  useQuery({
    enabled: !!uuid && enabled,
    queryKey: ["get-era-by-uuid", uuid],
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
    queryFn: async () =>
      new EraControllerApi(getConfigObject())
        .getEraByUuid(uuid as string, getXtenantId())
        .then((it) => it?.data?.data),
  });
